module.exports = __webpack_public_path__ + "img/es-ce.52485d6d.svg";